// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1W8RY","title":"Header_title__31olC","left":"Header_left__1hc0h","clinicName":"Header_clinicName__2xwJo"};